import { useState } from 'react'
import { ApplicationRoleItem } from '../AppRolesPanel'
import { Menu, MenuTrigger, Button, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components'
import { Navigation24Regular } from '@fluentui/react-icons'
import { AddApplicationRoleForm } from '@/ui/Forms/AddApplicationRoleForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'

export function RowActionsMenu({ item }: { item: ApplicationRoleItem }) {
  const [editAppRoleDrawerOpen, setEditAppRoleDrawerOpen] = useState<boolean>(false)
  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} />
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={() => {
                setEditAppRoleDrawerOpen(true)
              }}
            >
              Edit role
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      <OverlayDrawerComponent
        key="editform"
        open={editAppRoleDrawerOpen}
        setOpen={setEditAppRoleDrawerOpen}
        title="Edit application role"
        content={
          <AddApplicationRoleForm
            appId={item.applicationId}
            onSubmit={() => {
              setEditAppRoleDrawerOpen(false)
            }}
            selectedAppRole={item}
          />
        }
      />
    </>
  )
}
